import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getMatchTeams, getMatchTennisDouble, getReadyMatchId } from 'reducers/index';
import TennisDouble from 'newDesign/modules/break/components/statSlides/liveStats/liveStatsHeader/sports/tennisManager/tennisDoubles/TennisDoubles';
import TennisSingle from 'newDesign/modules/break/components/statSlides/liveStats/liveStatsHeader/sports/tennisManager/tennisSingle/TennisSingle';

const mapStateToProps = state => ({
  tennisDouble: getMatchTennisDouble(state, getReadyMatchId(state)),
  teams: getMatchTeams(state, getReadyMatchId(state)),
});

const TennisManager = ({
  tennisDouble, teams,
}) => {
  let tennisComponent;

  if (tennisDouble) {
    tennisComponent = <TennisDouble competitors={tennisDouble} />;
  } else if (teams) {
    tennisComponent = <TennisSingle competitors={teams} />;
  }

  return tennisComponent;
};

TennisManager.propTypes = {
  tennisDouble: PropTypes.object,
  teams: PropTypes.shape({
    home: PropTypes.array,
    away: PropTypes.array,
  }),
};

TennisManager.defaultProps = {
  tennisDouble: null,
  teams: {
    home: [{ name: '', abbr: '' }],
    away: [{ name: '', abbr: '' }],
  },
};

export default connect(mapStateToProps)(TennisManager);
